import { Toggle } from 'components/CheckboxToggle/types/Toggle';

export const getActiveToggles = (toggles: Toggle[]) =>
  toggles.filter((toggle) => toggle.active).map((item) => item.filter);
